import { render } from "./public_sells_receipt_details.vue?vue&type=template&id=08410c34"
import script from "./public_sells_receipt_details.vue?vue&type=script&lang=js"
export * from "./public_sells_receipt_details.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__